import { Popover as ChakraPopover, Portal } from '@chakra-ui/react'
import * as React from 'react'

export interface PopoverContentProps extends ChakraPopover.ContentProps {
  portalled?: boolean
  portalRef?: React.RefObject<HTMLElement | null>
  [key: string]: any
}

export const PopoverContent = React.forwardRef<
  HTMLDivElement,
  PopoverContentProps
>(function PopoverContent(props, ref) {
  const { portalled = true, portalRef, children, ...rest } = props

  const content = (
    <ChakraPopover.Positioner>
      <ChakraPopover.Content ref={ref} {...rest}>
        {children}
      </ChakraPopover.Content>
    </ChakraPopover.Positioner>
  )

  if (portalled) {
    return <Portal container={portalRef}>{content}</Portal>
  }

  return content
})

export const PopoverTrigger = ChakraPopover.Trigger
export const PopoverAnchor = ChakraPopover.Anchor
